module.exports = __webpack_public_path__ + "img/049.e3ffa5b0.jpg";